export default "__VITE_ASSET__CeOf1a3t__"